import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as domain from '@common/domain/entities/PartyAddress';
import * as models from '@common/domain/models/PartyAddressDTO';
import * as app from '@framework/app';
import { IApiServiceCommand } from '@services/api/api.service';
import { PartyAddressTypeEndPoints } from '@common/domain/entities/PartyAddressType';
import { FieldType } from '../../../framework/core/Enums';


export class PartyAddressFormFields extends Array<IFieldOptions> {
  public typeid: IFieldOptions = { field: "typeId", dataEndPoint: new PartyAddressTypeEndPoints().get, dataIdField: "id", dataDisplayField: "name" };
  public field1: IFieldOptions = { field: "field1" };
  public field2: IFieldOptions = { field: "field2" };
  constructor() {
    super();
    this.push(this.typeid);
    this.push(this.field1);
    this.push(this.field2);
  }
}

export class PartyAddressEndPoints extends domain.PartyAddressEndPoints implements IEntityEndPoints {
  get?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyAddress/" + serviceCommand.context.entityId
    }
  };
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyAddress/ForUser/"
    }
  };
  insert?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyAddress/CreateForUser/"
    },
    method: 'post'
  };
  delete?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyAddress/delete/" + serviceCommand.context.entityId
    },
    method: 'post'
  };
  update?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyAddress/update/" + serviceCommand.context.entityId
    },
    method: 'post'
  };
  search?: IDataEndPoint = null;
}
export class SupplierPartyAddressEndPoints extends domain.PartyAddressEndPoints implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/Supplier/partyAddress/" + serviceCommand.context.entityId
    }
  };
  search?: IDataEndPoint = null;
}

export class PartyAddressForm implements IFormOptions {
  protected PartyAddressFormName: string = "organisationForm";
  protected PartyAddressFormModel: models.PartyAddressDTO = new models.PartyAddressDTO();
  protected PartyAddressFormEndPoints: PartyAddressEndPoints = new PartyAddressEndPoints();
  protected PartyAddressFormFields: PartyAddressFormFields = new PartyAddressFormFields();
  public get name(): string { return this.PartyAddressFormName };
  public get model(): models.PartyAddressDTO { return this.PartyAddressFormModel };
  public get endPoints(): IEntityEndPoints { return this.PartyAddressFormEndPoints };
  public set endPoints(organisationEndPoints: IEntityEndPoints) {
    this.PartyAddressFormEndPoints = organisationEndPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
  public get fields(): PartyAddressFormFields { return this.PartyAddressFormFields };
}

export class PartyAddressListColumns extends Array<IColumnOptions>  {

  public PartyAddressType: IColumnOptions = { field: "typeId", dataEndPoint: new PartyAddressTypeEndPoints().get, dataIdField: "id", dataDisplayField: "name" };
  public PartyAddressField1: IColumnOptions = { field: "field1" };
  public PartyAddressField2: IColumnOptions = { field: "field2" };
  constructor() {
    super();
    this.push(this.PartyAddressType);
    this.push(this.PartyAddressField1);
    this.push(this.PartyAddressField2);
  }
}




export class PartyAddressList implements IGridOptions {
  protected PartyAddressListColumns: PartyAddressListColumns = new PartyAddressListColumns();
  protected PartyAddressListName: string = "PartyAddressList";
  protected PartyAddressListModel: models.PartyAddressDTO = new models.PartyAddressDTO();
  protected PartyAddressListEndPoints: PartyAddressEndPoints = new PartyAddressEndPoints();
  public get name(): string { return this.PartyAddressListName };
  public get model(): models.PartyAddressDTO { return this.PartyAddressListModel };
  public get endPoints(): IEntityEndPoints { return this.PartyAddressListEndPoints };
  public set endPoints(PartyAddressEndPoints: IEntityEndPoints) {
    this.PartyAddressListEndPoints = PartyAddressEndPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
  public get columns(): PartyAddressListColumns { return this.PartyAddressListColumns };
}

export class PartyAddressSpecificPartyEndPoints extends domain.PartyAddressEndPoints implements IEntityEndPoints {
  get?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyAddress/" + serviceCommand.context.entityId
    }
  };
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyAddress/ForUser/" + serviceCommand.context.entityId
    }
  };
  insert?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyAddress/CreateForUser/" + serviceCommand.context.parent.previousEntityId
    },
    method: 'post'
  };
  delete?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyAddress/delete/" + serviceCommand.context.entityId
    },
    method: 'post'
  };
  update?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyAddress/update/" + serviceCommand.context.entityId
    },
    method: 'post'
  };
  search?: IDataEndPoint = null;
}

export class PartyAddressSpecificPartyList extends PartyAddressList {
  protected PartyAddressListEndPoints: PartyAddressSpecificPartyEndPoints = new PartyAddressSpecificPartyEndPoints();
}

export class PartyAddresspecificPartyForm extends PartyAddressForm {
  protected PartyAddressFormEndPoints: PartyAddressSpecificPartyEndPoints = new PartyAddressSpecificPartyEndPoints();
}
export class SupplierPartyAddressList extends PartyAddressList {
  protected PartyAddressListEndPoints: SupplierPartyAddressEndPoints = new SupplierPartyAddressEndPoints();
}
